import { render, staticRenderFns } from "./sent_request.vue?vue&type=template&id=0e71ebb2&"
import script from "./sent_request.vue?vue&type=script&lang=js&"
export * from "./sent_request.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports